// extracted by mini-css-extract-plugin
export default {"social":"Social_social__m2eMI","icon":"Social_icon__sd9jl"};